import { useState } from 'react';

import { FieldBlueprint, FieldTypes, ParticipantRoles, SignatureFieldBlueprint } from '@zinnia/form-engine-sdk';

import { FieldDataHookReturnValue, useCastBlueprintToFieldType } from '../../Helpers/helperTypes';

export type SignatureFieldData = Pick<SignatureFieldBlueprint, 'participantRole'>;

export type SignatureFieldSetters = {
  setParticipantRole: React.Dispatch<React.SetStateAction<SignatureFieldData['participantRole']>>;
};

const defaultProperties = {
  participantRole: ParticipantRoles.INSURED,
} as const;

export function useSignatureFieldData({
  initialData,
}: {
  initialData?: Partial<FieldBlueprint>;
}): FieldDataHookReturnValue<SignatureFieldData, SignatureFieldSetters> {
  const initialDataAsSignatureField = useCastBlueprintToFieldType<SignatureFieldBlueprint>(
    FieldTypes.signature,
    initialData,
  );

  const [participantRole, setParticipantRole] = useState<SignatureFieldData['participantRole']>(
    initialDataAsSignatureField?.participantRole || defaultProperties.participantRole,
  );

  return {
    data: {
      participantRole,
    },
    setters: {
      setParticipantRole,
    },
    clearData: () =>
      setParticipantRole(initialDataAsSignatureField?.participantRole || defaultProperties.participantRole),
  };
}
